import React,  { PropTypes } from 'react';

const YoutubeVideo = (props) => {

  const { videoCode, 
          width,
          height,
          title } = props;

  const styles = {
    h2: {
        fontSize: '26px',
        marginTop: '10px',
        marginBottom: '5px',
        fontWeight: 'normal'
    },
    padre: {
        maxWidth: '600px',
        maxHeight: '400px'
    },
    contenedor: {
        position: 'relative',
        paddingBottom: '56.25%',
        paddingTop: '30px',
        overflow: 'hidden',
        maxWidth: '600px'
    },
    iframe: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%'
    }
  };

  return (
    <div>
        <h2 style={styles.h2}>{title}</h2>
        <center>
            <div style={styles.padre}>
                <div style={styles.contenedor}>
                    <iframe style={styles.iframe} 
                        width={width} 
                        height={height} 
                        src={"https://www.youtube.com/embed/" + videoCode}
                        frameBorder="0" 
                        allowFullScreen />
                </div>
            </div>
        </center>
    </div>
  );
};

YoutubeVideo.propTypes = {
    videoCode: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    title: PropTypes.string,
};

export default YoutubeVideo;



/** WEBPACK FOOTER **
 ** ./src/components/YoutubeVideo.js
 **/